import React from "react";

function NFTGamingPlatform() {
  return (
    <>
      <div className="aobut-style-six-area default-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading">
                <h4 className="sub-title">About Robok</h4>
                <h2 className="title">
                  NFT Gaming Platform Development By Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container container-stage-left">
          <div className="row">
            <div className="col-lg-6">
              <div className="about-style-six-left-info">
                <img
                  src="https://validthemes.net/site-template/robok/assets/img/about/5.jpg"
                  alt="Image Not Found"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-style-six-right-info">
                <p>
                  At Xeer Technology, we specialize in NFT Gaming Platform
                  Development that merges the excitement of gaming with the
                  innovative power of blockchain technology. Our dedicated team
                  is committed to creating immersive gaming experiences where
                  players can truly own, trade, and earn from their in-game
                  assets through non-fungible tokens (NFTs).
                </p>

                <a href="about-us.html" className="btn btn-style-one">
                  Know More
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 text-end">
              <div className="about-six-fun-fact bg-gray">
                <div className="fun-fact">
                  <div className="js-counter">
                    <span
                      className="js-counter-num"
                      data-target="4.95"
                      data-decimals={0}
                      data-index={0}
                    >
                      4.95
                    </span>
                  </div>
                  <h5>Positive Review</h5>
                </div>
                <div className="fun-fact">
                  <div className="js-counter">
                    <span
                      className="js-counter-num"
                      data-target={218}
                      data-decimals={0}
                      data-index={0}
                    >
                      218
                    </span>
                    M
                  </div>
                  <h5>Worldwide Users</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-six-features bg-dark text-light bg-cover"
                style={{
                  backgroundImage:
                    "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
                }}
              >
                <ul>
                  <li>
                    <h4>AI Strategy and Consulting</h4>
                    <p>
                      It's a holistic process that aligns AI capabilities with
                      business goals to create value, improve efficiency.
                    </p>
                  </li>
                  <li>
                    <h4>Machine Learning Solutions</h4>
                    <p>
                      A Machine Learning Solution is a comprehensive system
                      designed to solve a specific problem or automate.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTGamingPlatform;
